import { Icon } from "@iconify/react";
import { useState } from "react";
import AuthDialog from "../auth/AuthDialog";
import { HealthyLife, StartFreeTrail } from "./LandingPage";
import Testimonials from "./Testimonials";

export default function TestimonialsPage() {
  const [showAuth, setShowAuth] = useState(false);
  return (
    <div className="flex flex-col w-full h-full bg-primary-midBlack">
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <div className="w-full  py-20">
        <div className="px-5 md:px-32">
          <a href="/">
            <p className="text-white font-bold flex flex-row items-center gap-1">
              <span>
                <Icon
                  icon="ic:baseline-arrow-right-alt"
                  className="rotate-180"
                />
              </span>
              Go back to the home page
            </p>
          </a>
          <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug mt-10">
            Success <span className="text-primary-neonGreen">Stories</span>
          </p>

          <Testimonials />
        </div>
      </div>
      <HealthyLife
        openAuth={() => {
          setShowAuth(true);
        }}
      />
      <StartFreeTrail
        openAuth={() => {
          setShowAuth(true);
        }}
      />
    </div>
  );
}
